export default function setRumGlobalContext(datadogRum, context) {
  if (!datadogRum || !context) {
    return;
  }
  if (typeof datadogRum.setRumGlobalContext === 'function') {
    datadogRum.setRumGlobalContext(context);
    return;
  }
  if (typeof datadogRum.setGlobalContext === 'function') {
    datadogRum.setGlobalContext(context);
    return;
  }
  if (typeof datadogRum.setGlobalContextProperty === 'function') {
    Object.keys(context).forEach(key => {
      datadogRum.setGlobalContextProperty(key, context[key]);
    });
    return;
  }
  if (typeof datadogRum.addRumGlobalContext === 'function') {
    Object.keys(context).forEach(key => {
      if (typeof datadogRum.removeRumGlobalContext === 'function') {
        datadogRum.removeRumGlobalContext(key);
      }
      datadogRum.addRumGlobalContext(key, context[key]);
    });
  }
}